import { classNames, h, signal, tag } from "omi";
import { isEmpty } from "lodash-es";

import type { TextValidation } from "@/wc/editor/components";
import { tailwind } from "@/tailwind";
import { decodeData } from "@/utils";

import { DocBase } from "../docBase.tsx";
import { DocumentTheme, DocumentThemeDef } from "../models.ts";

type Props = {
  title: string;
  placeholder?: string;
  theme: DocumentTheme;
};

@tag("nw-doc-text")
export class NWDocText extends DocBase<Props> {
  static css = [tailwind, `:host { box-sizing: border-box; }`];
  static propTypes = {
    title: String,
    placeholder: String,
    theme: String,
  };

  private text = signal<string | undefined>(undefined);

  installed() {
    const hydrationData = this.getAttribute("data");
    if (hydrationData == null) {
      return;
    }

    const validation = decodeData<TextValidation>(hydrationData);
    this.text.value = validation.text?.data;
  }

  public getText() {
    return this.text.value;
  }

  render() {
    const themeDef = DocumentThemeDef[this.props.theme];

    return (
      <div id="container" class="space-y-4 my-12">
        {!isEmpty(this.props.title) && (
          <h2 id="title" class={classNames("text-2xl font-medium", themeDef.font)}>
            {this.props.title}
          </h2>
        )}

        <p class={classNames("text-lg tracking-tight", themeDef.font)}>{this.text.value ?? this.props.placeholder}</p>
      </div>
    );
  }
}
